import { useTranslation } from "react-i18next";

/**
 * Success screen shown after a successful feedback submission.
 * SVG checkmark draws in via stroke-dashoffset; the surrounding card
 * fades and scales using the existing `wizardSuccess` keyframe so
 * timings stay consistent with the import wizard's celebration.
 */
export function ThankYouAnimation() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: "32px 8px 24px",
        textAlign: "center",
        animation: "wizardSuccess 600ms cubic-bezier(.2,.7,.3,1) both",
      }}
    >
      <div
        style={{
          position: "relative",
          width: 88,
          height: 88,
          margin: "0 auto 18px",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            background: "var(--ok, #2f855a)",
            opacity: 0.12,
            animation: "wizardRipple 900ms ease-out both",
          }}
        />
        <div
          style={{
            position: "absolute",
            inset: 8,
            borderRadius: "50%",
            background: "var(--ok, #2f855a)",
            opacity: 0.18,
          }}
        />
        <svg
          viewBox="0 0 56 56"
          width={88}
          height={88}
          aria-hidden="true"
          style={{ position: "absolute", inset: 0 }}
        >
          <circle
            cx="28"
            cy="28"
            r="22"
            fill="none"
            stroke="var(--ok, #2f855a)"
            strokeWidth="3"
            strokeDasharray="140"
            strokeDashoffset="140"
            style={{ animation: "feedbackCircleDraw 480ms ease-out 80ms forwards" }}
          />
          <path
            d="M17 29 L25 37 L40 21"
            fill="none"
            stroke="var(--ok, #2f855a)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="40"
            strokeDashoffset="40"
            style={{ animation: "feedbackCheckDraw 420ms ease-out 360ms forwards" }}
          />
        </svg>
      </div>
      <div
        style={{
          fontFamily: "var(--font-display)",
          fontSize: 22,
          lineHeight: 1.2,
          marginBottom: 6,
        }}
      >
        {t("feedback.thankYouTitle")}
      </div>
      <div style={{ fontSize: 14, color: "var(--ink-3)" }}>{t("feedback.thankYouBody")}</div>
    </div>
  );
}
